import { createElement } from 'react';
import { Card } from '@alifd/next';
import './index.scss';
const OadpCard = function OadpCard({ media, title, subTitle, actions, showTitleBullet, showHeadDivider, contentHeight, extra, free, hasBorder, ...otherProps }) {
    return (createElement(Card, Object.assign({ title: title, media: media, subTitle: subTitle, actions: actions, showTitleBullet: showTitleBullet, showHeadDivider: showHeadDivider, contentHeight: contentHeight, extra: extra, free: free, hasBorder: hasBorder }, otherProps)));
};
export default OadpCard;
